import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { store, persistor } from './redux/store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { CookiesProvider } from "react-cookie";

// Create a root element for React rendering
const root = ReactDOM.createRoot(document.getElementById('root'));
// Render the application
root.render(
  <CookiesProvider>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <App /> 
        </PersistGate>
      </Provider>
  </CookiesProvider>
);